// ANETT HORVATH — House Metrics (Silent Analytics)
// Admin-only. No marketing. Operational metrics only.

export interface HouseMetrics {
  active_members: number;
  waitlist_count: number;
  total_orders: number;
  total_revenue_eur: number;
  allocation_success_rate: number;
  avg_approval_days: number;
  tier_distribution: Record<string, number>;
  timestamp: string;
}

const METRICS_KEY = 'ah_house_metrics';

export function computeMetrics(store: any): HouseMetrics {
  const members = (store.members || []).filter((m: any) => !m.deleted_at);
  const orders = (store.orders || []).filter((o: any) => !o.deleted_at);
  const paidOrders = orders.filter((o: any) => o.status === 'paid');

  const tierDist: Record<string, number> = {};
  members.filter((m: any) => m.status === 'active').forEach((m: any) => {
    tierDist[m.access_tier] = (tierDist[m.access_tier] || 0) + 1;
  });

  const approved = members.filter((m: any) => m.approved_at);
  let avgApproval = 0;
  if (approved.length > 0) {
    const totalDays = approved.reduce((sum: number, m: any) => {
      return sum + (new Date(m.approved_at).getTime() - new Date(m.created_at).getTime()) / 86400000;
    }, 0);
    avgApproval = Math.round(totalDays / approved.length * 10) / 10;
  }

  const metrics: HouseMetrics = {
    active_members: members.filter((m: any) => m.status === 'active').length,
    waitlist_count: members.filter((m: any) => m.status === 'waitlist').length,
    total_orders: paidOrders.length,
    total_revenue_eur: paidOrders.reduce((s: number, o: any) => s + o.amount_eur, 0),
    allocation_success_rate: 0, // TODO: compute from allocation module when data exists
    avg_approval_days: avgApproval,
    tier_distribution: tierDist,
    timestamp: new Date().toISOString(),
  };

  localStorage.setItem(METRICS_KEY, JSON.stringify(metrics));
  return metrics;
}

export function getLastMetrics(): HouseMetrics | null {
  try { const r = localStorage.getItem(METRICS_KEY); return r ? JSON.parse(r) : null; } catch { return null; }
}
